export class IONote {

    public noteId:string;
    public activityId:string;
    public contactId:string;
    public accountId:string;
    public objectId:string;
    public createdTime:Date;
    public noteText:string;
    public ownerName:string;
    public ownerId:string;
    public hasDocument:boolean;
    public documentDataURL:string;
    public documentName:string;
    public documentSize:number;
    public documentMimeType:string;
    public isDeleted = false;
    public pendingPushForDynamics = false;
    public updated = false;
    public consentActivityId: string;
    public isOffLabel = false;

    constructor(raw: IONoteDTO){
        this.noteId = (raw['annotationid']) ? raw['annotationid'] : raw['noteId'] ? raw['noteId'] : '';
        this.activityId = (raw['activityid'] ? raw['activityid'] : (raw['activityId'] ? raw['activityId'] : '' ) );
        this.contactId = (raw['contactid']) ? raw['contactid'] : raw['contactId'] ? raw['contactId'] : '';
        this.accountId = (raw['accountid']) ? raw['accountid'] : '';
        this.objectId= (raw['objectid'])? raw['objectid'] : (raw['objectId']? raw['objectId']: '');
        this.createdTime = IONote.parseCreatedTime(raw['createdon'] || raw['createdTime']);
        this.noteText = (raw['notetext']) ? raw['notetext'].replace(/<[^>]*>/g, '') : raw['noteText'] ? raw['noteText'].replace(/<[^>]*>/g, '') : '';
        this.ownerName = (raw['ownerName']) ? raw['ownerName'] : '';
        this.ownerId = (raw['ownerid']) ? raw['ownerid'] : raw['ownerId'] ? raw['ownerId'] : '';
        this.hasDocument = (raw['isdocument']) ? raw['isdocument'] : raw['hasDocument'] ? raw['hasDocument'] : false;
        this.documentDataURL = (raw['documentbody']) ? raw['documentbody'] : raw['documentDataURL'] ? raw['documentDataURL'] : '';
        this.documentName = (raw['filename']) ? raw['filename'] : raw['documentName'] ? raw['documentName'] : '';
        this.documentSize = (raw['filesize']) ? raw['filesize'] : raw['documentSize'] ? raw['documentSize'] : 0;
        this.documentMimeType = (raw['mimetype']) ? raw['mimetype'] : raw['documentMimeType'] ? raw['documentMimeType'] : '';
        this.pendingPushForDynamics = (raw['pendingPushForDynamics']) ? raw['pendingPushForDynamics'] : raw['isDeleted'] ? raw['isDeleted'] : false;
        this.isDeleted = raw['deleted'] ? raw['deleted'] : raw['isDeleted'] ? raw['isDeleted'] : false;
        this.updated = raw['updated'] ? raw['updated'] : false;
        this.consentActivityId = (raw['consentActivityId'] ? raw['consentActivityId'] : (raw['consentActivityid'] ? raw['consentActivityid'] : '' ) );
        this.isOffLabel = raw['isOffLabel'] ? raw['isOffLabel'] : raw['subject'] === 'OFFLABEL';
    }

    /**
     * Normalise the many shapes `createdon`/`createdTime` arrives in into a valid
     * Date (or null). Callers pass:
     *  - a Date instance — Dynamics responses parsed by dynamics-web-api, whose
     *    dateReviver converts ISO strings like "2026-06-09T07:23:23Z" into Date
     *    objects. (The old `new Date(parseInt(date))` produced "Invalid Date"
     *    here, crashing DatePipe — OMNI-57234 SDR notes.)
     *  - an epoch-millisecond number or numeric string — the legacy contract used
     *    by cached/offline records (e.g. `new Date(x).getTime().toString()`).
     *  - an ISO-8601 / Date-parseable string — responses not run through the
     *    reviver (e.g. timestamps carrying fractional seconds).
     * Anything unparseable returns null so the template renders an empty string
     * instead of feeding "Invalid Date" to DatePipe.
     */
    private static parseCreatedTime(value: any): Date | null {
        if (!value) return null;
        if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
        if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value.trim()))) {
            const epoch = new Date(Number(value));
            return isNaN(epoch.getTime()) ? null : epoch;
        }
        const parsed = new Date(value);
        return isNaN(parsed.getTime()) ? null : parsed;
    }
}

export interface IONoteDTO {
  annotationid?: string;
  isdocument?: boolean;
  hasDocument?: boolean;
  notetext?: string;
  createdon?: any;
  ownerid?: string;
  ownerName?: string;
  filename?: string;
  filesize?: number;
  mimetype?: string;
  documentbody?: string;
  activityid?: string;
  accountid?: string;
  contactid?: string;
  kitbookingid?: string;
  pendingPushForDynamics?: boolean;
  deleted?: boolean;
  isDeleted?: boolean;
  updated?: boolean;
  objecttypecode?: string;
  isOffLabel?: boolean;
  subject?: string;
}
